import React from 'react'
import { createPortal } from 'react-dom'
import { Button } from '@mobi/component-library/Common/V2/Buttons'
import { Tray } from '@mobi/component-library/Overlays/Tray'
import { SettingItem } from '../Common/SettingItem'
import { EditPresetTrayContent } from './Components/EditPresetTrayContent'

export const KeypadDenominationsSetting: React.FC = () => {
  const [isTrayOpen, setIsTrayOpen] = React.useState(false)

  return (
    <SettingItem
      label='BetSlip keyboard presets'
      description='Save up to 3 custom amounts for one tap selection when placing a bet'
      rightComponent={
        <Button onClick={() => setIsTrayOpen(true)} color='tertiary_grey'>
          Edit
        </Button>
      }
      bottomComponent={createPortal(
        <Tray
          isOpen={isTrayOpen}
          headerTitle='Edit BetSlip Keyboard'
          dismissStatus='allowed'
          onDismiss={() => setIsTrayOpen(false)}
        >
          <EditPresetTrayContent hideTray={() => setIsTrayOpen(false)} />
        </Tray>,
        document.body
      )}
    />
  )
}
